import React from 'react';
import { motion } from 'framer-motion';
import { Github, Linkedin, GraduationCap, Building2 } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const Slide14Team = () => {
    return (
        <div className="w-full h-full bg-background p-8 lg:p-16 flex flex-col justify-center relative">
            {/* Background Grid Texture */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
                style={{ backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)', backgroundSize: '40px 40px' }}
            />
            <motion.div className="text-center mb-16">
                <h2 className="text-4xl lg:text-6xl font-bold mb-4">Built by <span className="text-primary">Engineers</span> & Builders</h2>
                <p className="text-xl text-muted-foreground">Capital-efficient structure. Founders on zero salary initially.</p>
            </motion.div>

            <div className="flex flex-col lg:flex-row gap-12 max-w-6xl mx-auto w-full">

                {/* Founders Column */}
                <div className="lg:w-2/3 grid grid-cols-1 md:grid-cols-2 gap-8">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="bg-card border border-primary/50 p-6 rounded-2xl flex flex-col items-center text-center shadow-[0_0_30px_rgba(0,255,0,0.05)]"
                    >
                        <div className="w-32 h-32 rounded-full border-2 border-primary overflow-hidden mb-4">
                            <Avatar className="w-full h-full">
                                <AvatarImage src="/images/ani.png" />
                                <AvatarFallback className="bg-secondary text-2xl font-bold">F1</AvatarFallback>
                            </Avatar>
                        </div>
                        <h3 className="text-2xl font-bold text-white">Anirban Mallick</h3>
                        <p className="text-primary font-medium mb-4">Founders</p>
                        <div className="text-sm text-muted-foreground space-y-2 mb-6">
                            <p className="flex items-center justify-center gap-2"><GraduationCap className="w-4 h-4" /> AI/ML Specialist</p>
                            <p className="flex items-center justify-center gap-2"><Building2 className="w-4 h-4" /> CSE Background</p>
                        </div>
                        <div className="flex gap-4">
                            <a href="https://www.linkedin.com/in/anirban-mallick021/" target="_blank" rel="noopener noreferrer">
                                <Linkedin className="w-5 h-5 text-muted-foreground hover:text-white cursor-pointer" />
                            </a>
                            {/*<Github className="w-5 h-5 text-muted-foreground hover:text-white cursor-pointer" />*/}
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.1 }}
                        className="bg-card border border-primary/50 p-6 rounded-2xl flex flex-col items-center text-center shadow-[0_0_30px_rgba(0,255,0,0.05)]"
                    >
                        <div className="w-32 h-32 rounded-full border-2 border-primary overflow-hidden mb-4">
                            <Avatar className="w-full h-full">
                                <AvatarImage src="/images/deep.png" />
                                <AvatarFallback className="bg-secondary text-2xl font-bold">F2</AvatarFallback>
                            </Avatar>
                        </div>
                        <h3 className="text-2xl font-bold text-white">Deep Jain</h3>
                        <p className="text-primary font-medium mb-4">Founders</p>
                        <div className="text-sm text-muted-foreground space-y-2 mb-6">
                            <p className="flex items-center justify-center gap-2"><GraduationCap className="w-4 h-4" /> Business Specialist</p>
                            <p className="flex items-center justify-center gap-2"><Building2 className="w-4 h-4" /> MBA Background</p>
                        </div>
                        <div className="flex gap-4">
                            <a href="https://www.linkedin.com/in/djdeep/" target="_blank" rel="noopener noreferrer">
                                <Linkedin className="w-5 h-5 text-muted-foreground hover:text-white cursor-pointer" />
                            </a>
                            {/*<Github className="w-5 h-5 text-muted-foreground hover:text-white cursor-pointer" />*/}
                        </div>
                    </motion.div>
                </div>

                {/* Core Team List */}
                <div className="lg:w-1/3 flex flex-col justify-center">
                    <h3 className="text-xl font-bold text-white mb-6 border-b border-border pb-2">Core Team</h3>
                    <ul className="space-y-6">
                        {[
                            { role: "Senior Full-Stack Developer", bg: "App Development" },
                            { role: "Senior AI/ML Engineer", bg: "LLM Development" },
                            { role: "Compliance Associate", bg: "Legal/Reg Background" },
                        ].map((member, i) => (
                            <motion.li
                                key={i}
                                initial={{ opacity: 0, x: 20 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ delay: 0.2 + (i * 0.1) }}
                                className="flex items-center gap-4"
                            >
                                <div className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center font-bold text-muted-foreground">
                                    {i + 1}
                                </div>
                                <div>
                                    <p className="font-bold text-white">{member.role}</p>
                                    <p className="text-sm text-muted-foreground">{member.bg}</p>
                                </div>
                            </motion.li>
                        ))}
                    </ul>
                </div>

            </div>
        </div>
    );
};

export default Slide14Team;